export default class ExploreCard {
    /**
     * @var {boolean}
     */
    showVideo = false;

    /**
     * @var {HTMLElement}
     */
    video = null;

    /**
     * @var {boolean}
     */
    videoPlaying = false;

    /**
     * @var {string}
     */
    videoTime = "00:00";

    /**
     * @var {number}
     */
    videoProgress = 0;

    /**
     * @var {boolean}
     */
    showVideoControls = false;

    init() {
        this.initVideo();
    }

    initVideo() {
        this.video = this.$el.querySelector('video');
        if(!this.video) {
            return;
        }
        // this.video.addEventListener('timeupdate', this.updateProgress.bind(this));
        // this.video.addEventListener('loadedmetadata', this.setMaxRange.bind(this));
        // this.initVideoTracker();
    }

    initVideoTracker() {
        const slider = this.$root.querySelector('input[type="range"]');

        slider.addEventListener("change", () => {
            const percentage = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
            slider.style.setProperty("--progress", `${percentage}%`);
        });
            
    }

    togglePlay() {
        if (this.video.paused) {
            this.video.play();
            this.videoPlaying = true;
        } else {
            this.video.pause();
            this.videoPlaying = false;
        }
    }

    updateProgress() {
        this.videoProgress = (this.video.currentTime / this.video.duration) * 100;
        this.videoTime = this.formatTime(this.video.currentTime);

        const slider = this.$root.querySelector('input[type="range"]');

        const percentage = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
        slider.style.setProperty("--progress", `${percentage}%`);
    }

    setMaxRange() {
        this.$el.querySelector('.range').max = this.video.duration;
    }

    updateVideoTracking(event) {
        const newTime = event.target.value * this.video.duration / 100;
        this.video.currentTime = newTime;
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
        return `${mins}:${secs}`;
    }

    toggleShowVideo(hideOnly = false) {
        if(this.showVideo || hideOnly) {
            this.showVideo = false;
            this.video.pause();
            this.videoPlaying = false;
        } else {
            this.showVideo = true;
            this.video.play();
            this.videoPlaying = true;
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("exploreCard", () => new ExploreCard());
});
